export default [
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "Create from",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "Create to",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "From load date",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "To load date",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "From delivery date",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "To delivery date",
        placeholder: app.$i18n.t("Date"),
        class: "font-small-3",
        model: null,
        locale: "en",
        dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        },
        cols: 6,
    },
];